import { Outlet } from 'react-router';
import { css } from '@repo/themes/styled-system/css';
import apipanaLogo from '@/assets/personal_attendance/apipana_logo.svg';

const BackgroundImageLayout = () => {
  return (
    <>
      <img
        src={apipanaLogo}
        className={css({
          position: 'absolute',
          right: '0',
          maxHeight: 'screen',
        })}
      />
      <main
        className={css({
          margin: '0',
          height: '[100dvh]',
        })}
      >
        <Outlet />
      </main>
    </>
  );
};

export default BackgroundImageLayout;
